import { StateCreator } from 'zustand';

interface ISearchState {
  searchById: Record<string, any>;
}

interface ISearchActions {
  setSearchById: (id: string, search: any) => void;
}

export interface ISearchStore extends ISearchState, ISearchActions {}

export const createSearchSlice: StateCreator<ISearchStore> = (set, get) => ({
  searchById: {},
  setSearchById: (id: string, search: any) => {
    set(state => ({
      searchById: {
        ...state.searchById,
        [id]: search,
      },
    }));
  },
});
